import * as React from "react";
import { Info20Regular } from "@fluentui/react-icons";

type MessageValue = string | number | { title?: string };
interface IMessageBannerProps {
    messages: MessageValue[];
    messageType: MessageType;
    resetMessageBanner: () => void;
    isNotClosable?: boolean;
}

export enum MessageType {
    Success,
    Danger,
    Information,
    Warning
}

export class MessageBanner extends React.Component<IMessageBannerProps>{
    constructor(props: IMessageBannerProps) {
        super(props);
    }

    render() {
        const { messages, messageType, resetMessageBanner, isNotClosable } = this.props;

        const normalizeMessage = (m: MessageValue): string => {
            if (typeof m === "string") return m;
            if (typeof m === "number") return m + ""; // convert to string
            if (typeof m === "object") return m.title ?? "An unexpected error occurred";
            return "Unknown error";
        };

        const renderMessages = () => {
            if (!messages || messages.length === 0) return null;

            if (messages.length === 1)
                return <div>{normalizeMessage(messages[0])}</div>;

            return (
                <ul>
                    {messages.map((m, i) => (
                        <li key={i}>{normalizeMessage(m)}</li>
                    ))}
                </ul>
            );
        };

        const renderClassName = (): string => {
            let className: string = "col-md-12 alert alert-dismissible fade in";
            switch (messageType) {
                case MessageType.Success:
                    className += " alert-success"
                    break;
                case MessageType.Danger:
                    className += " alert-danger"
                    break;
                case MessageType.Information:
                    className += " alert-info"
                    break;
                case MessageType.Warning:
                    className += " alert-warning"
                    break;
            }
            return className;
        }

        if (messageType === MessageType.Information) {
        return <div className={renderClassName()} data-testid="info-message-banner">
            <a className="close" aria-label="close" onClick={resetMessageBanner}>&times;</a>
                <div className="alert-content">
                    <Info20Regular className="icon info" />
                    <span className="text">
            {renderMessages()}
                    </span>
                </div>
        </div>
        }
        else {
            return <div className={renderClassName()} data-testid="general-message-banner">
                {isNotClosable ? <></> : <a className="close" aria-label="close" onClick={resetMessageBanner}>&times;</a>}
                {renderMessages()}
            </div>
        }
    }
}